import React from 'react'
import { component_tool } from '@/tool'
const { WizComponent, WizRate } = component_tool;

export default class QsRate extends WizComponent {
    render() {
        const { preview, answer } = this.props
        let rateProps = {
            allowHalf: true,
            count:10
        }

        if (!preview) {
            rateProps = { ...rateProps, value: Number(answer), disabled: true }
        }

        return (
            <WizRate {...rateProps} />
        )
    }
}